import React from "react";
import HomesectionCard from "./HomesectionCard";

const Homesection2 = () => {
  return (
   < div id="values">
    <div className="mt-44  pt-48 pb-48 lg:mt-40">
      <div className="mx-8 text-center text-blue-900">
        <h1 className="text-4xl font-bold">OUR <a className="underline decoration-orange-700"> VALUES   </a> </h1>
        <p className="mt-10 text-2xl font-semibold text-gray-800">
          Values are what make your environment unique
        </p>
      </div>
      <div className=" mt-8  justify-evenly  lg:flex text-right lg:h-[35rem] w-screen">
        <HomesectionCard
          image="https://images.unsplash.com/photo-1497633762265-9d179a990aa6?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8ZWR1Y2F0aW9ufGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60"
          heading="MOTTO"
          heading1="Who we are ?"
          heading2="“Lead me from darkness to light”"
        />

        <HomesectionCard
          image="https://images.unsplash.com/photo-1497633762265-9d179a990aa6?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8ZWR1Y2F0aW9ufGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60"
          heading="MISSION"
          heading1=" What we value ?
         "
          heading2="Our mission is to work together to build a safe, respectful and nurturing environment focused on maximizing each child’s sense of wellbeing and acquisition of skills for life and learning."
        />

        <HomesectionCard
          image="https://images.unsplash.com/photo-1497633762265-9d179a990aa6?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8ZWR1Y2F0aW9ufGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60"
          heading="VISION"
          heading1="What we want to become ?"
          heading2="Our vision is to empower students to acquire, demonstrate, articulate and value knowledge and skills that will support them, as life-long learners, to participate in and contribute to the global world and practise the core values of the school: respect, tolerance & inclusion, and excellence."
        />
      </div>
    </div>
    </div>
  );
};

export default Homesection2;
